import type { BoatInfo } from '../contexts/BoatContext';
import { sessionService } from './sessionService';

const BOAT_INFO_KEY = 'boatInfo';

export const boatInfoService = {
    saveBoatInfo: (boatInfo: BoatInfo) => {
        sessionService.setSessionData(BOAT_INFO_KEY, boatInfo);
    },

    getBoatInfo: (): BoatInfo | null => {
        return sessionService.getSessionData(BOAT_INFO_KEY);
    },

    clearBoatInfo: () => {
        sessionService.clearSession();
    }
};